// @ts-nocheck
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  CircularProgress,
  ClickAwayListener,
  Tooltip,
  Typography,
  useMediaQuery,
  Box,
} from "@mui/material";
import { Link, NavLink, useNavigate } from "react-router-dom";
import ReusableParentContainer from "../Custom/ReusableParentContainer";
import Logo1 from "../../assets/images/Horizontal_logo.svg";
import Favicon from "../../assets/images/SP_2025_LogoSquare_noBGnolines.svg";
import InfoIcon from "../../assets/images/Info-Square.svg";
import { NotificationIcon } from "../../assets/svgs/SVGs";
import user from "../../assets/images/user.png";
import { updateEventInfoAction } from "../../store/actions/createEvent";
import { getLatestLogsOfUserAction } from "../../store/actions/logs";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import {
  convertFromUTCToGivenTimezone,
  getTimeAndDateString,
} from "../../utils/methods/dateAndTimeMethods";
import { fetchUnreadNotificationsCount } from "../../store/actions/notifications";
import { isUserRole, isActiveRole } from "../../utils/methods/storeFunc";
import { USER_ROLES } from "../../staticData/userRoles";
import EventNotesNotificationTooltip from "./components/EventNotesNotificationTooltip";
import RoleSwitcher from "./components/RoleSwitcher";
import ChatUnreadTooltip from "./components/ChatUnreadTooltip";
import { ChatBadge } from "./components/NotesBadge";
import SupportNavButton from "./SupportNavButton";
import {
  NAV_STACK_MEDIA_QUERY,
  navActionsSx,
  navBellSpacingSx,
  navIdentitySx,
  navShortcutsSx,
} from "./navActionsLayout";

const NavBar = ({ accountOnly = false }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const auth = useSelector((store) => store.auth);
  const createContactInfo = useSelector((store) => store.createContactInfo);
  const notifications = useSelector((store) => store.notifications);
  const logs = useSelector((store) => store.logs);

  const eventInfo = createContactInfo?.eventInfo;
  const { eventOneOnOneNotesOfAssignee, updatedChatMetaData } = useSelector(
    (state) => state.notifications,
  );
  const [showUserLogs, setShowUserLogs] = useState(false);

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // Logo: o wordmark horizontal (20rem) vira o quadradinho no MESMO ponto em
  // que a navbar empilha (1200px) — antes a troca era em 600px, então entre
  // 600 e 1200px sobrava um logo de 320px ao lado de um bloco já empilhado.
  const isNavStacked = useMediaQuery(NAV_STACK_MEDIA_QUERY);

  const getActivityTimeHandler = ({ activityTime, timezone }) => {
    return getTimeAndDateString(
      convertFromUTCToGivenTimezone({
        dateStr: activityTime,
        timezone,
      }),
    );
  };

  useEffect(() => {
    if (eventInfo && !eventInfo?.userId && auth?.userId && auth?.userToken) {
      if (!isActiveRole(USER_ROLES.CLIENT)) return;
      dispatch(
        updateEventInfoAction({
          payload: {
            userId: auth?.userId,
            ...eventInfo,
          },
          _id: eventInfo?._id,
          successCallback: () => {},
          userAuth: auth,
        }),
      );
    }
  }, [auth?.userId, auth?.userToken, dispatch]);

  React.useEffect(() => {
    if (!auth?.userToken || accountOnly) return;
    dispatch(fetchUnreadNotificationsCount());
    const timer = window.setInterval(() => dispatch(fetchUnreadNotificationsCount()), 30000);
    return () => window.clearInterval(timer);
  }, [auth?.userToken, dispatch, accountOnly]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "25px 40px",
        zIndex: 9,
      }}
    >
      <Box>
        <Link
          to={
            auth?.userToken
              ? accountOnly
                ? "/show-media-gallery"
                : isUserRole(
                  USER_ROLES.CLIENT,
                  USER_ROLES.ADMIN,
                  USER_ROLES.SUPERADMIN,
                )
                  ? "/dashboard"
                  : isActiveRole(USER_ROLES.COORDINATOR)
                    ? "/dashboard"
                    : isActiveRole(USER_ROLES.CONTRACTOR)
                      ? "/opportunities/not-responded"
                      : "/"
              : "/"
          }
          onClick={(e) => {
            if (location.pathname === "/dashboard") {
              e.preventDefault();
              location.reload();
            }
          }}
        >
          <img
            style={{
              width: isNavStacked ? "4.5rem" : "20rem",
            }}
            src={isNavStacked ? Favicon : Logo1}
          />
          {/* <img */}
          {/*   style={{ */}
          {/*     width: isSmallScreen ? "2.5rem" : "20rem", */}
          {/*   }} */}
          {/*   src={isSmallScreen ? Favicon : Logo} */}
          {/* /> */}
        </Link>
      </Box>

      {auth?.userToken ? (
        <>
          <Box sx={navActionsSx}>
            {/* Atalhos — abaixo de 1200px descem para uma 2ª linha, embaixo
                da identidade (ver navActionsLayout.ts). */}
            {!accountOnly && <Box sx={navShortcutsSx}>
              <EventNotesNotificationTooltip />
              <ChatUnreadTooltip />
              {/*<ClickAwayListener
              onClickAway={() => {
                setShowUserLogs(false);
              }}
            >
              <Tooltip
                open={showUserLogs}
                slotProps={{
                  tooltip: {
                    sx: {
                      maxWidth: "1000px",
                    },
                  },
                }}
                title={
                  <>
                    <Box
                      sx={{
                        width: "22rem",
                        height: "700px",
                      }}
                    >
                      {logs?.recentLogs?.isLoading ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          <CircularProgress size={22} />
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.5rem",
                            boxShadow: `7px 7px 20px rgba(209, 117, 182, 0.15), 
                            -7px 7px 20px rgba(209, 117, 182, 0.15)`,
                            overflowY: "scroll",
                            height: "100%",
                            paddingRight: "0.35rem",
                          }}
                        >
                          {logs?.recentLogs?.data?.map?.(
                            (currLog, currLogIdx) => {
                              return (
                                <React.Fragment key={currLog?._id}>
                                  <ReusableParentContainer
                                    style={{
                                      width: "100%",
                                      padding: "10px",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "0.5rem",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          textAlign: "left",
                                        }}
                                      >
                                        {currLog?.description}
                                      </Typography>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          gap: "4rem",
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            width: "fit-content",
                                            fontSize: "0.7rem",
                                          }}
                                        >
                                          {getActivityTimeHandler?.({
                                            activityTime: currLog?.activityTime,
                                            timezone: currLog?.eventTimezone,
                                          })}
                                        </Typography>
                                        <Typography
                                          sx={{
                                            width: "fit-content",
                                            fontSize: "0.75rem",
                                          }}
                                        >
                                          - {currLog?.actionByUserName || "N/A"}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </ReusableParentContainer>
                                </React.Fragment>
                              );
                            },
                          )}
                        </Box>
                      )}
                    </Box>
                  </>
                }
                arrow
              >
                <Box
                  sx={{
                    lineHeight: "0",
                    marginRight: isSmallScreen ? "12px" : "24px",
                  }}
                  onClick={() => {
                    setShowUserLogs(true);
                  }}
                >
                  <Button
                    sx={{
                      minWidth: "0",
                      background: "transparent",
                      border: "none",
                      boxShadow: "none",
                      padding: "0",
                      ": hover": {
                        background: "transparent",
                        border: "none",
                        boxShadow: "none",
                      },
                    }}
                    onClick={() => {
                      if (!logs?.recentLogs?.dataLoadedOnce) {
                        dispatch(getLatestLogsOfUserAction({}));
                      }
                    }}
                  >
                    <img src={InfoIcon} />
                  </Button>
                </Box>
              </Tooltip>
            </ClickAwayListener>
*/}

              <SupportNavButton isSmallScreen={isSmallScreen} />

              <Box sx={navBellSpacingSx(isSmallScreen)}>
                <NavLink to={"/notifications"}>
                  <ChatBadge
                    totalUnread={
                      notifications?.notificationsCount
                        ?.unreadNotificationsCount >= 0
                        ? notifications?.notificationsCount
                            ?.unreadNotificationsCount > 99
                          ? `99+`
                          : notifications?.notificationsCount
                              ?.unreadNotificationsCount
                        : ""
                    }
                  >
                    <NotificationIcon
                      style={{
                        // marginTop: "0.35rem",
                        width: "32px",
                        height: "40.25px",
                      }}
                    />
                  </ChatBadge>
                </NavLink>
              </Box>
            </Box>}

            {/* Identidade: papel + nome + foto. Empilhado fica na 1ª linha,
                acima dos atalhos (column-reverse). */}
            <Box sx={navIdentitySx}>
              {/* Role switcher — só aparece se user tem 2+ roles aprovados */}
              <RoleSwitcher />

              <Link to="/profile">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {!isSmallScreen && (
                    <Box>
                      <Typography>
                        Hi,{" "}
                        <Typography variant="span" sx={{ color: "#00EEC5" }}>
                          {auth?.userName}
                        </Typography>
                      </Typography>
                      <Typography>Welcome Back!</Typography>
                    </Box>
                  )}
                  <Box
                    sx={{
                      marginLeft: "8px",
                      width: "64px",
                      height: "64px",
                      borderRadius: "100%",
                      border: "1px solid #D175B6",
                      "& img": {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      },
                    }}
                  >
                    <img
                      src={auth?.imageUrl || user}
                      style={{
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  </Box>
                </Box>
              </Link>
              <Typography variant="h1" color="primary"></Typography>
            </Box>
          </Box>
        </>
      ) : (
        <>
          <Box sx={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <Typography>
              {isSmallScreen ? "" : "Continue as "}
              <Typography
                sx={{ color: "#00EEC5", display: "inline" }}
                // onClick={() => {
                //   // window.location.reload();
                //   navigate("/");
                // }}
              >
                Guest
              </Typography>
            </Typography>
            <Typography>or</Typography>
            <NavLink
              to="/login"
              style={{
                background:
                  "linear-gradient(107.95deg, #FF00FF 0%, #8F00FF 65.99%),linear-gradient(0deg, #FFFFFF, #FFFFFF)",
                borderRadius: "40px",
                padding: isSmallScreen ? "8px 15px" : "8px 35px",
                border: "2px solid white",
              }}
              onClick={() => navigate("/login")}
            >
              LOG IN
            </NavLink>
          </Box>
        </>
      )}
    </Box>
  );
};

export default NavBar;
